import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpHeaderService } from '../shared/services/httpheader.service';
import { FindRepairShopComponent } from './find-repair-shop.component';
import { MapPlotComponent } from './map-plot/map-plot.component';
import { SearchBarComponent } from './search-bar/search-bar.component';

@NgModule({
  declarations: [
    FindRepairShopComponent,
    SearchBarComponent,
    MapPlotComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [
    FindRepairShopComponent,
    SearchBarComponent,
    MapPlotComponent
  ],
  providers: [HttpHeaderService]
})
export class FindRepairShopModule {}
